export default __webpack_public_path__ + "static/media/rotaryLogo.59f39647.jpg";